import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/images/logo.png";

export default function Footer() {
  return (
    <footer className="cinfa-footer mt-5">

      {/* Top Gradient Line */}
      <div className="footer-gradient-line"></div>

      <Container className="py-4">
        <Row className="align-items-center">

          {/* Left Logo */}
          <Col md={6} className="text-md-start text-center mb-3 mb-md-0">
            <img
              src={logo}
              alt="Batterjee Logo"
              style={{ height: "40px" }}
            />
          </Col>

          {/* Right Content */}
          <Col md={6} className="text-md-end text-center small text-muted">
            <div>© {new Date().getFullYear()} LABORATORIOS Batterjee</div>
            <div>
              <a href="/" className="footer-link">Batterjee Spain</a> |{" "}
              <a href="/" className="footer-link">Legal Notice</a> |{" "}
              <a href="/" className="footer-link">Privacy Policy</a> |{" "}
              <a href="/" className="footer-link">Cookies Policy</a>
            </div>
          </Col>

        </Row>
      </Container>
    </footer>
  );
}